/**
 * 인기상품 컨트롤 플래그, DB 컬럼 추가하는 거 아까워서 boolean으로 처리
 * @type {boolean}
 */
export const isBestSellerShow = true;
